import { action, observable, computed, makeObservable } from "mobx";
import { RecallCampaign } from "./RecallModels";

export default class CurrentRecallModel {
  constructor() {
    makeObservable(this);
  }
  @observable response: RecallCampaign[] = [];
  @observable isContentExist: boolean = false;
  @observable isRequestError: boolean = false;

  @computed get length() {
    return this.response ? this.response.length : 0;
  }

  @action reset = () => {
    this.response = null;
    this.isContentExist = false;
    this.isRequestError = false;
  };
}
